// lib/features/search/search.service.ts
import apiService from "../../api/api.service";
import {
  HomeSearchListResponse,
  SaveSearchRequest,
  SaveSearchResponse,
  ClearSearchResponse,
  BulkDeleteSearchRequest,
  BulkDeleteSearchResponse,
  SearchResultsRequest,
  SearchResultsResponse,
  GetFavoriteSearchesRequest,
  GetFavoriteSearchesResponse,
  SearchSuggestionsResponse,
} from "./search.types";

export const fetchHomeSearchList = () => {
  return apiService.get<HomeSearchListResponse>("/general/home-search-list");
};

export const saveSearch = (data: SaveSearchRequest) => {
  return apiService.post<SaveSearchResponse, SaveSearchRequest>(
    "/customers/searches",
    data,
  );
};

export const clearSearchHistory = () => {
  return apiService.post<ClearSearchResponse>("/customers/searches/clear");
};

export const bulkDeleteSearches = (data: BulkDeleteSearchRequest) => {
  return apiService.delete<BulkDeleteSearchResponse>(
    "/customers/searches/bulk-delete",
    data,
  );
};

export const fetchSearchResults = ({ search, page, per_page, section_id, seque, ...filterFields }: SearchResultsRequest) => {
  const filters = Object.fromEntries(
    Object.entries(filterFields).filter(([, v]) => v !== undefined),
  );
  return apiService.get<SearchResultsResponse>("/general/search", {
    params: {
      search,
      page,
      per_page,
      ...(section_id !== undefined ? { section_id } : {}),
      ...(seque !== undefined ? { seque } : {}),
      ...(Object.keys(filters).length ? { filters } : {}),
    },
  });
};

export const getFavoriteSearches = (params?: GetFavoriteSearchesRequest) => {
  return apiService.get<GetFavoriteSearchesResponse>("/customers/searches", {
    params,
  });
};

export const fetchSearchSuggestions = (search: string) => {
  return apiService.get<SearchSuggestionsResponse>("/general/search/suggest", {
    params: { search },
  });
};

export const fetchImageSearchResults = (image: File, page = 1, per_page = 20) => {
  const form = new FormData();
  form.append("image", image);
  form.append("search_type", "image");
  form.append("page", String(page));
  form.append("per_page", String(per_page));
  return apiService.post<SearchResultsResponse, FormData>("/general/search", form);
};
